import { JOB_CONSTANTS } from "src/constants/job.constants";
import { SIDEBAR_CONSTANTS } from "src/constants/sidebarConstants";
import { URL_CONSTANTS } from "src/constants/url.constants";

const urlList = [
  {
    action: {
      type: "route",
      route: JOB_CONSTANTS.ADD_JOB,
    },
    moduleId: SIDEBAR_CONSTANTS.JOB_ROUTE,
  },
  {
    action: {
      type: "route",
      route: JOB_CONSTANTS.EDIT_JOB,
    },
    moduleId: SIDEBAR_CONSTANTS.JOB_ROUTE,
  },
  {
    action: {
      type: "route",
      route: URL_CONSTANTS.PROSPECT_ADD,
    },
    moduleId: SIDEBAR_CONSTANTS.PROSPECTS_ROUTE,
  },
  {
    action: {
      type: "route",
      route: URL_CONSTANTS.PROSPECT_VIEW,
    },
    moduleId: SIDEBAR_CONSTANTS.PROSPECTS_ROUTE,
  },
  {
    action: {
      type: "route",
      route: URL_CONSTANTS.PROSPECT_EDIT,
    },
    moduleId: SIDEBAR_CONSTANTS.PROSPECTS_ROUTE,
  },
  {
    action: {
      type: "route",
      route: URL_CONSTANTS.PROSPECT_IMPORT_LOG,
    },
    moduleId: SIDEBAR_CONSTANTS.PROSPECTS_ROUTE,
  },
  {
    action: {
      type: "route",
      route: URL_CONSTANTS.INVOICE,
    },
    moduleId: SIDEBAR_CONSTANTS.INVOICE,
  },
];

export default urlList;
